<!-- 新用户专属奖励弹窗 -->
<template>
    <div class="mask display-x-center display-y-center">
        <div class="tip-content-a">
            <img class="content-bg" :src="require('@/assets/images/home/prop/' + t('activitys.img.4'))" />
            <div class="btn-confirm" @click="onConfirm"></div>
            <img class="btn-close" src="@/assets/images/common/btn_close.png" @click="onConfirm" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { receiveNewUserReward } from '@/api/v4';
import { LOCAL_STORE } from '@/config/constConfig';

const { t } = useI18n();

const emits = defineEmits(["onClose"]);

function onConfirm() {
    emits('onClose');
    receiveNewUserReward({}).then((res: any) => {
        if (res.data.success) {
            localStorage.setItem(LOCAL_STORE.IS_SHOW_NEWPLAYER, "1");
        }
    });
}
</script>

<style lang="less" scoped>
.tip-content-a {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: #23252A;
    border-radius: 5rem;
    .content-bg {
        width: 345rem;
    }
    .btn-confirm {
        position: absolute;
        width: 250rem;
        height: 50rem;
        transform: translateX(-50%);
        bottom: 20rem;
        left: 50%;
    }
    .btn-close {
        width: 30rem;
        height: 30rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -50rem;
    }
}
</style>